import StudentPoliciesAPI from '@/apis/business/studentPoliciesAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('StudentPolicies', StudentPoliciesAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    _config: {
      field: {
        key: 'Id',
        name: 'StudentPolicyName',
      },
    },
    studentPolicies: [],
  },
  mutations: {
    ...crudBase.mutations,

    setStudentPolicies (state, studentPolicies) {
      state.studentPolicies = studentPolicies
    },
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
    /**
       * Load danh sách
       */
    async getAllAsync (context, payload) {
      let res = null
      try {
        context.commit('updateLoading', true)
        res = await StudentPoliciesAPI.getAllAsync(payload || {})
      } finally {
        context.commit('updateLoading', false)
      }
      if (res) {
        context.commit('setStudentPolicies', res)
      }
      return res
    },

    /**
       * Lấy all bản ghi
       */
    async loadAll (context, payload) {
      let res = null

      try {
        context.commit('updateLoading', true)
        res = await StudentPoliciesAPI.getAll(payload || {})
      } finally {
        context.commit('updateLoading', false)
      }

      if (res) {
        context.commit('setAllData', res)
      }

      return res
    },
  },
}
